import { render } from "./ExportTasksModal.vue?vue&type=template&id=d2edc59a"
import script from "./ExportTasksModal.vue?vue&type=script&lang=js"
export * from "./ExportTasksModal.vue?vue&type=script&lang=js"
script.render = render

export default script